import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/arrow сircle.svg` */
export const ArrowCircleIcon = createTripletGlyphIcon('ArrowCircleIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5166 5.94336C4.74636 5.7451 5.09344 5.77046 5.29199 6L8.10059 9.25098L10.6963 6.01562C10.8864 5.77876 11.2328 5.74057 11.4697 5.93066C11.7064 6.12082 11.7438 6.46728 11.5537 6.7041L8.60742 10.376C8.35974 10.6837 7.89332 10.6923 7.63477 10.3936L4.45996 6.71973C4.26142 6.48998 4.287 6.14201 4.5166 5.94336Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00098 1.33301C11.6821 1.3334 14.6668 4.31884 14.667 8C14.6668 11.6812 11.6821 14.6656 8.00098 14.666C4.31971 14.6658 1.33422 11.6813 1.33398 8C1.3342 4.31873 4.3197 1.33322 8.00098 1.33301ZM8.00098 2.33105C4.8704 2.33126 2.33225 4.86943 2.33203 8C2.33226 11.1306 4.87041 13.6687 8.00098 13.6689C11.1314 13.6685 13.6697 11.1304 13.6699 8C13.6697 4.86954 11.1314 2.33145 8.00098 2.33105Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.12598 6.73828C5.35573 6.54006 5.70282 6.56543 5.90137 6.79492L9.11523 10.5146L12.0869 6.81055C12.277 6.57376 12.6235 6.53551 12.8604 6.72559C13.0971 6.91573 13.1344 7.26219 12.9443 7.49902L9.62988 11.6299C9.37807 11.9427 8.90339 11.9513 8.64062 11.6475L5.06934 7.51465C4.87083 7.28495 4.8965 6.93695 5.12598 6.73828Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00098 1.50098C13.1425 1.50124 16.4999 4.85848 16.5 9C16.4999 13.1415 13.1425 16.4988 9.00098 16.499C4.85937 16.4989 1.50111 13.1416 1.50098 9C1.5011 4.85839 4.85936 1.5011 9.00098 1.50098ZM9.00098 2.62207C5.4789 2.62219 2.62317 5.47793 2.62305 9C2.62318 12.5221 5.47891 15.3778 9.00098 15.3779C12.5229 15.3777 15.3788 12.522 15.3789 9C15.3788 5.47802 12.5229 2.62233 9.00098 2.62207Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.82422 8.97168C7.13762 8.70118 7.6111 8.73555 7.88184 9.04883L12.1523 13.9912L16.1035 9.06934C16.3628 8.74679 16.8343 8.69512 17.1572 8.9541C17.48 9.21316 17.532 9.6848 17.2734 10.0078L12.8535 15.5156C12.5114 15.9416 11.8672 15.9533 11.5098 15.54L6.74707 10.0293C6.47625 9.71592 6.51088 9.24253 6.82422 8.97168Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 2.00098C17.5231 2.00116 21.9998 6.47788 22 12C21.9998 17.5221 17.5231 21.9988 12.001 21.999C6.47886 21.9988 2.00213 17.5221 2.00195 12C2.00213 6.47788 6.47886 2.00116 12.001 2.00098ZM12.001 3.49707C7.30491 3.49725 3.49823 7.30393 3.49805 12C3.49823 16.6961 7.30491 20.5037 12.001 20.5039C16.697 20.5037 20.5047 16.6961 20.5049 12C20.5047 7.30393 16.697 3.49725 12.001 3.49707Z"
        fill="currentColor"
      />
    </svg>
  ),
});
